<ng-template #noMobileStyle>
  <ng-container>
    <div class="popover-container">
      <div class="popover-image-container">
        <img [src]="icon" class="popover-image" />
      </div>
      <div class="detail-container" [ngSwitch]="myTitle">
        <ng-container *ngSwitchCase="'PAY_AT_DESTINATION'">
          <span i18n="@@payments_options_alerts_pay_at_destination">
            ¡Hay un precio más barato pagando en el alojamiento!
          </span>
        </ng-container>
        <ng-container *ngSwitchCase="'PREPAID'">
          <span i18n="@@payments_options_alerts_prepaid">
            ¡Hay un precio más barato pagando en cuotas!
          </span>
        </ng-container>
        <ng-container *ngSwitchCase="'OTHER_OPTIONS'">
          <span i18n="@@payments_options_alerts_other_options">
            ¡Hay otras opciones de habitación sin cancelación gratis!
          </span>
        </ng-container>
        <ng-container *ngSwitchCase="'CHEAPER'">
          <span i18n="@@payments_options_alerts_cheaper_price">
            ¡Genial! Bajó el precio del alojamiento.
          </span>
        </ng-container>
        <ng-container *ngSwitchCase="'EXPENSIVE'">
          <span i18n="@@payments_options_alerts_expensive_price">
            Ups, el alojamiento actualizó el precio.
          </span>
        </ng-container>
        <ng-container *ngSwitchCase="'RESULT-FLEXIBLE-FILTER'">
          <span i18n="@@flexiblerate_alert">
            ¡Comprá tranquilo!<br />Reservá alojamientos que puedas cancelar.
          </span>
        </ng-container>
        <ng-container *ngSwitchCase="'RESULT-FILTERS-PREPAID'">
          <span i18n="@@pagas_ahora_en_pesos"> Pagás ahora en pesos. </span>
        </ng-container>
        <ng-container *ngSwitchCase="'RESULT-FILTERS-PAY_AT_DESTINATION'">
          <span i18n="@@necesitas_una_tarjeta_de_credito_para_garantizar_la_reserva">
            Necesitás una tarjeta de crédito para garantizar la reserva.
          </span>
        </ng-container>
      </div>
    </div>
  </ng-container>
</ng-template>
<ng-container *ngIf="mobileStyle; else noMobileStyle">
  <ng-container *ngIf="openAlert">
    <div class="container-mobile">
      <div class="row alert-container-mobile">
        <div class="col">
          <img [src]="icon" />
        </div>
        <div class="detail-container-mobile" [ngSwitch]="myTitle">
          <ng-container *ngSwitchCase="'PAY_AT_DESTINATION'">
            <span i18n="@@payments_options_alerts_pay_at_destination">
              ¡Hay un precio más barato pagando en el alojamiento!
            </span>
          </ng-container>
          <ng-container *ngSwitchCase="'PREPAID'">
            <span i18n="@@payments_options_alerts_prepaid">
              ¡Hay un precio más barato pagando en cuotas!
            </span>
          </ng-container>
          <ng-container *ngSwitchCase="'OTHER_OPTIONS'">
            <span i18n="@@payments_options_alerts_other_options">
              ¡Hay otras opciones de habitación sin cancelación gratis!
            </span>
          </ng-container>
          <ng-container *ngSwitchCase="'CHEAPER'">
            <span i18n="@@payments_options_alerts_cheaper_price">
              ¡Genial! La habitación tiene un mejor precio.
            </span>
          </ng-container>
          <ng-container *ngSwitchCase="'EXPENSIVE'">
            <span i18n="@@payments_options_alerts_expensive_price">
              Ups, el alojamiento actualizó el precio.
            </span>
          </ng-container>
        </div>
      </div>
      <div class="col close-container-mobile" (click)="hide()"></div>
    </div>
  </ng-container>
</ng-container>
